import { Button } from '@ics-portal/guardian';
import type { ResolvedColumn, ResolvedFilter } from '../../domain';
import { Icon } from '../shared/Icon';
import { chipValue, operatorLabelFor } from './utils';

export interface ChipProps<T> {
    filter: ResolvedFilter;
    column?: ResolvedColumn<T>;
    onRemove: (key: string) => void;
}

export function Chip<T>(props: ChipProps<T>): JSX.Element {
    const { filter, column, onRemove } = props;
    const header = column?.header ?? filter.key;
    const operatorLabel = operatorLabelFor(filter.type, filter.operator);
    const values = Array.isArray(filter.value)
        ? filter.value
        : [String(filter.value)];
    const [first, ...rest] = values;
    return (
        <span
            className={
                filter.locked
                    ? 'ics-table__search-chip ics-table__search-chip--locked'
                    : 'ics-table__search-chip'
            }
        >
            <span className="ics-table__search-chip-col">
                {header}
                {operatorLabel ? ` ${operatorLabel.toLowerCase()}` : ''}:{' '}
            </span>
            {chipValue(column, first)}
            {rest.length > 0 ? ` +${String(rest.length)}` : null}
            {filter.locked ? null : (
                <Button
                    icon={<Icon name="close" />}
                    className="ics-table__search-chip-remove"
                    aria-label={`Remove filter ${header}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove(filter.key);
                    }}
                />
            )}
        </span>
    );
}
